'use client'
import { useEffect, useState } from 'react'
import Icon from './Icon'

export default function ScrollIndicator() {
  const [visible, setVisible] = useState(true)

  useEffect(() => {
    const handleScroll = () => setVisible(window.scrollY < 100)
    handleScroll()
    window.addEventListener('scroll', handleScroll, { passive: true })
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  return (
    <>
      <style>{`
        @keyframes float {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(6px); }
        }
        .scroll-float {
          animation: float 2s ease-in-out infinite;
        }
      `}</style>
      <div
        className={`absolute bottom-8 left-1/2 -translate-x-1/2 scroll-float flex flex-col items-center text-[#475569] transition-opacity duration-500 ${
          visible ? 'opacity-100' : 'opacity-0 pointer-events-none'
        }`}
      >
        <Icon name="chevron-down" className="w-5 h-5" />
      </div>
    </>
  )
}
